/* Shared by the real-cart adapter and the isolated preview. Amounts are integer cents. */
(function(root) {
  const normalize = value => String(value || '').trim().toUpperCase();
  function inspect(cart, config, now = Date.now()) {
    const ids = config.variants.map(v => String(v.id));
    const gifts = cart.items.filter(item => ids.includes(String(item.variant_id || item.id)));
    const subtotal = cart.items.filter(item => !ids.includes(String(item.variant_id || item.id)) && !item.gift_card)
      .reduce((sum, item) => sum + Number(item.original_line_price || 0), 0);
    const codes = (cart.discount_codes || []).filter(d => d.applicable).map(d => normalize(d.code));
    const allocations = [...(cart.cart_level_discount_applications || []), ...cart.items.flatMap(i => (i.line_level_discount_allocations || []).map(a => a.discount_application))];
    const otherDiscount = codes.some(c => c !== normalize(config.code)) || allocations.some(a => normalize(a.title) !== normalize(config.code));
    const active = now >= Date.parse(config.startsAt) && now < Date.parse(config.endsAt);
    const currencyOK = cart.currency === config.currency;
    const qualifies = active && currencyOK && subtotal >= config.minimum;
    const giftCount = gifts.reduce((sum, i) => sum + i.quantity, 0);
    const giftFree = gifts.length > 0 && gifts.every(i => i.final_line_price === 0 && (i.line_level_discount_allocations || []).some(a => normalize(a.discount_application.title) === normalize(config.code)));
    const validGift = qualifies && giftCount === 1 && codes.includes(normalize(config.code)) && !otherDiscount && giftFree;
    return { gifts, subtotal, remaining: Math.max(0, config.minimum - subtotal), active, currencyOK, qualifies, otherDiscount, giftCount, giftFree, validGift };
  }
  const api = { normalize, inspect };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  root.BootyRules = api;
})(typeof window === 'undefined' ? globalThis : window);
